function getTheme(prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  if (prefix) prefix += "-";
  var colors = {
    red0: "#820000",
    red1: "#a80707",
    red2: "#cf1313",
    red3: "#f52222",
    red4: "#ff4d4a",
    red5: "#ff7570",
    red6: "#ff9c96",
    red7: "#ffcfcc",
    red8: "#fff1f0",
    vermilion0: "#801f06",
    vermilion1: "#a63111",
    vermilion2: "#cc471f",
    vermilion3: "#f26130",
    vermilion4: "#ff8559",
    vermilion5: "#ffa480",
    vermilion6: "#ffc1a6",
    vermilion7: "#ffdccc",
    vermilion8: "#fff1eb",
    orange0: "#873b00",
    orange1: "#ad4e00",
    orange2: "#d46708",
    orange3: "#fa8416",
    orange4: "#ff9e3d",
    orange5: "#ffb463",
    orange6: "#ffc88a",
    orange7: "#ffdfb8",
    orange8: "#fff4e5",
    yellow0: "#8c5600",
    yellow1: "#b27100",
    yellow2: "#d9910b",
    yellow3: "#ffb219",
    yellow4: "#ffc240",
    yellow5: "#ffd166",
    yellow6: "#ffde8c",
    yellow7: "#ffebb2",
    yellow8: "#fff9e5",
    lemon0: "#8c6c00",
    lemon1: "#b28c00",
    lemon2: "#d9ad00",
    lemon3: "#ffd30d",
    lemon4: "#ffdd33",
    lemon5: "#ffe659",
    lemon6: "#ffee80",
    lemon7: "#fff6b2",
    lemon8: "#fffce5",
    kelly0: "#4e6600",
    kelly1: "#698c00",
    kelly2: "#84b205",
    kelly3: "#a0d911",
    kelly4: "#b0e535",
    kelly5: "#c3f25c",
    kelly6: "#d7ff87",
    kelly7: "#e4ffb2",
    kelly8: "#f6ffe5",
    green0: "#175200",
    green1: "#267804",
    green2: "#3b9e0d",
    green3: "#52c41a",
    green4: "#6fd13b",
    green5: "#8ede5f",
    green6: "#aeeb88",
    green7: "#cff7b5",
    green8: "#edffe0",
    lake0: "#004b4f",
    lake1: "#006a75",
    lake2: "#08999c",
    lake3: "#13c2c2",
    lake4: "#34cecc",
    lake5: "#58dbd7",
    lake6: "#80e8e3",
    lake7: "#abf5f0",
    lake8: "#e5fffd",
    cobalt0: "#08448c",
    cobalt1: "#145eb2",
    cobalt2: "#237bd9",
    cobalt3: "#369afe",
    cobalt4: "#5cb0ff",
    cobalt5: "#82c5ff",
    cobalt6: "#a3d6ff",
    cobalt7: "#c2e4ff",
    cobalt8: "#ebf6ff",
    blue0: "#082D8C",
    blue1: "#0D37A1",
    blue2: "#0B4FD3",
    blue3: "#0F61FF",
    blue4: "#3479FF",
    blue5: "#6196FF",
    blue6: "#84AEFF",
    blue7: "#B4CDFF",
    blue8: "#E9F0FF",
    violet0: "#1e1173",
    violet1: "#2d1f99",
    violet2: "#3629cc",
    violet3: "#5245e5",
    violet4: "#766df2",
    violet5: "#9e99ff",
    violet6: "#c1bfff",
    violet7: "#e1e0ff",
    violet8: "#f5f5ff",
    rose0: "#4f0080",
    rose1: "#6c08a6",
    rose2: "#8c14cc",
    rose3: "#b230f2",
    rose4: "#ca59ff",
    rose5: "#d980ff",
    rose6: "#e6a6ff",
    rose7: "#f1ccff",
    rose8: "#fcf2ff",
    pink0: "#78064a",
    pink1: "#9e1063",
    pink2: "#c41d7c",
    pink3: "#eb2f96",
    pink4: "#f757ac",
    pink5: "#ff80c1",
    pink6: "#ffa6d2",
    pink7: "#ffcce5",
    pink8: "#fff2f8",
    gray0: "#212533",
    gray1: "#474e66",
    gray2: "#69718c",
    gray3: "#8f98b2",
    gray4: "#b3bacc",
    gray5: "#cacfde",
    gray6: "#dde2f0",
    gray7: "#ebeef5",
    gray8: "#f2f4fa",
    grayA: "#f4f7fc",
    grayS: "#f6f6fb",
    white0: "#fff",
    black0: "#000",
    brandActive: "rgb(var(--".concat(prefix, "primary-7))"),
    brandNormal: "rgb(var(--".concat(prefix, "primary-6))"),
    brandHover: "rgb(var(--".concat(prefix, "primary-5))"),
    brandLine: "rgb(var(--".concat(prefix, "primary-4))"),
    brandDisabled: "rgb(var(--".concat(prefix, "primary-3))"),
    brandPressed: "rgb(var(--".concat(prefix, "primary-2))"),
    brandSelected: "rgb(var(--".concat(prefix, "primary-1))"),
    brandSelectedbg: "var(--".concat(prefix, "color-bg-brand-selected)"),
    // 兼容设计稿命名
    primaryActive: "rgb(var(--".concat(prefix, "primary-7))"),
    primaryNormal: "rgb(var(--".concat(prefix, "primary-6))"),
    primaryHover: "rgb(var(--".concat(prefix, "primary-5))"),
    primaryLine: "rgb(var(--".concat(prefix, "primary-4))"),
    primaryDisabled: "rgb(var(--".concat(prefix, "primary-3))"),
    primaryPressed: "rgb(var(--".concat(prefix, "primary-2))"),
    primarySelected: "rgb(var(--".concat(prefix, "primary-1))"),
    primarySelectedbg: "var(--".concat(prefix, "color-bg-brand-selected)"),
    stateNormal: "var(--".concat(prefix, "color-border-state-normal)"),
    stateHover: "var(--".concat(prefix, "color-border-state-hover)"),
    statePressed: "var(--".concat(prefix, "color-border-state-pressed)"),
    stateActive: "var(--".concat(prefix, "color-border-state-active)"),
    stateDisabled: "var(--".concat(prefix, "color-border-state-disabled)"),
    stateSelectedHover: "var(--".concat(prefix, "color-border-state-selected-hover)"),
    stateSelectedPressed: "var(--".concat(prefix, "color-border-state-selected-pressed)"),
    neutralText1: "var(--".concat(prefix, "color-text-1)"),
    neutralText2: "var(--".concat(prefix, "color-text-2)"),
    neutralText3: "var(--".concat(prefix, "color-text-3)"),
    neutralText4: "var(--".concat(prefix, "color-text-4)"),
    neutralText5: "var(--".concat(prefix, "color-text-5)"),
    neutralLine1: "var(--".concat(prefix, "color-border-1)"),
    neutralLine2: "var(--".concat(prefix, "color-border-2)"),
    neutralBg1: "var(--".concat(prefix, "color-bg-bg1)"),
    neutralBg2: "var(--".concat(prefix, "color-bg-bg2)"),
    neutralBg3: "var(--".concat(prefix, "color-bg-bg3)"),
    neutralBg4: "var(--".concat(prefix, "color-bg-bg4)"),
    neutralWhite: "var(--".concat(prefix, "color-bg-white)"),
    neutralBlack: "var(--".concat(prefix, "color-fill-black)"),
    functionLink: "rgb(var(--".concat(prefix, "link-6))"),
    functionLinkHover: "rgb(var(--".concat(prefix, "link-5))"),
    functionLinkActive: "rgb(var(--".concat(prefix, "link-7))"),
    functionLinkPressed: "rgb(var(--".concat(prefix, "link-4))"),
    functionLinkDisabled: "rgb(var(--".concat(prefix, "link-3))"),
    functionError: "rgb(var(--".concat(prefix, "danger-6))"),
    functionErrorHover: "rgb(var(--".concat(prefix, "danger-5))"),
    functionErrorActive: "rgb(var(--".concat(prefix, "danger-7))"),
    functionErrorPressed: "rgb(var(--".concat(prefix, "danger-4))"),
    functionErrorDisabled: "rgb(var(--".concat(prefix, "danger-1))"),
    functionErrorLine: "rgb(var(--".concat(prefix, "danger-2))"),
    functionErrorBg: "var(--".concat(prefix, "color-bg-function-error)"),
    functionWarning: "rgb(var(--".concat(prefix, "warning-6))"),
    functionWarningHover: "rgb(var(--".concat(prefix, "warning-5))"),
    functionWarningActive: "rgb(var(--".concat(prefix, "warning-7))"),
    functionWarningPressed: "rgb(var(--".concat(prefix, "warning-4))"),
    functionWarningDisabled: "rgb(var(--".concat(prefix, "warning-1))"),
    functionWarningLine: "rgb(var(--".concat(prefix, "warning-2))"),
    functionWarningBg: "var(--".concat(prefix, "color-bg-function-warning)"),
    functionSuccess: "rgb(var(--".concat(prefix, "success-6))"),
    functionSuccessHover: "rgb(var(--".concat(prefix, "success-5))"),
    functionSuccessActive: "rgb(var(--".concat(prefix, "success-7))"),
    functionSuccessPressed: "rgb(var(--".concat(prefix, "success-4))"),
    functionSuccessDisabled: "rgb(var(--".concat(prefix, "success-1))"),
    functionSuccessLine: "rgb(var(--".concat(prefix, "success-2))"),
    functionSuccessBg: "var(--".concat(prefix, "color-bg-function-success)"),
    auxiliaryRed: "rgb(var(--".concat(prefix, "auxiliary-red-5))"),
    auxiliaryRedText: "rgb(var(--".concat(prefix, "auxiliary-red-5))"),
    auxiliaryRedLine: "rgb(var(--".concat(prefix, "auxiliary-red-7))"),
    auxiliaryRedBg: "rgb(var(--".concat(prefix, "auxiliary-red-4))"),
    auxiliaryOrange: "rgb(var(--".concat(prefix, "auxiliary-orange-5))"),
    auxiliaryOrangeText: "rgb(var(--".concat(prefix, "auxiliary-orange-5))"),
    auxiliaryOrangeLine: "rgb(var(--".concat(prefix, "auxiliary-orange-7))"),
    auxiliaryOrangeBg: "rgb(var(--".concat(prefix, "auxiliary-orange-4))"),
    auxiliaryGreen: "rgb(var(--".concat(prefix, "auxiliary-green-5))"),
    auxiliaryGreenText: "rgb(var(--".concat(prefix, "auxiliary-green-5))"),
    auxiliaryGreenLine: "rgb(var(--".concat(prefix, "auxiliary-green-7))"),
    auxiliaryGreenBg: "rgb(var(--".concat(prefix, "auxiliary-green-4))"),
    auxiliaryCobalt: "rgb(var(--".concat(prefix, "auxiliary-cobalt-5))"),
    auxiliaryCobaltText: "rgb(var(--".concat(prefix, "auxiliary-cobalt-5))"),
    auxiliaryCobaltLine: "rgb(var(--".concat(prefix, "auxiliary-cobalt-7))"),
    auxiliaryCobaltBg: "var(--".concat(prefix, "color-bg-auxiliary-cobalt)"),
    auxiliaryYellow: "rgb(var(--".concat(prefix, "auxiliary-yellow-5))"),
    auxiliaryYellowText: "rgb(var(--".concat(prefix, "auxiliary-yellow-5))"),
    auxiliaryYellowLine: "rgb(var(--".concat(prefix, "auxiliary-yellow-7))"),
    auxiliaryYellowBg: "var(--".concat(prefix, "color-bg-auxiliary-yellow)"),
    auxiliaryNeutral: "var(--".concat(prefix, "color-auxiliary-neutral-normal)"),
    auxiliaryNeutralLine: "var(--".concat(prefix, "color-auxiliary-neutral-line)"),
    auxiliaryNeutralBg: "var(--".concat(prefix, "color-auxiliary-neutral-bg)"),
    neutralMask: "var(--".concat(prefix, "color-mask-neutral)"),
    brandGreen: "var(--".concat(prefix, "color-brand-green)"),
    brandRed: "var(--".concat(prefix, "color-brand-red)"),
    brandWhite: "var(--".concat(prefix, "color-brand-white)"),
    brandBlack: "var(--".concat(prefix, "color-brand-black)"),
    tableSelected: 'rgba(235, 247, 247, 1)',
    tablePressed: 'rgba(237, 237, 237, 1)',
    tableBorder: 'rgba(230, 230, 230, 1)',
    tableCellHover: 'rgba(242, 242, 242, 1)',
    tableCellExpand: 'rgba(250, 250, 250, 1)'
  };
  var boxShadow = {
    downS: "0 2px 8px rgba(0, 0, 0, 0.06)",
    downM: "0 4px 12px rgba(0, 0, 0, 0.12)",
    downL: "0 8px 20px rgba(0, 0, 0, 0.12)",
    upS: "0 -2px 8px rgba(0, 0, 0, 0.06)",
    upM: "0 -4px 12px rgba(0, 0, 0, 0.12)",
    upL: "0 -8px 20px rgba(0, 0, 0, 0.12)",
    leftS: "-2px 0 8px rgba(0, 0, 0, 0.06)",
    leftM: "-4px 0 12px rgba(0, 0, 0, 0.12)",
    leftL: "-8px 0 20px rgba(0, 0, 0, 0.12)",
    rightS: "2px 0 8px rgba(0, 0, 0, 0.06)",
    rightM: "4px 0 12px rgba(0, 0, 0, 0.12)",
    rightL: "8px 0 20px rgba(0, 0, 0, 0.12)"
  };
  var border = {
    borderWidthS: "1px",
    borderWidthM: "2px",
    borderWidthL: "4px",
    borderRadiusS: "2px",
    borderRadiusM: "4px",
    borderRadiusL: "8px",
    borderRadiusHalf: "50%"
  };
  var space = {
    space1: "4px",
    space2: "8px",
    space3: "12px",
    space4: "16px",
    space5: "24px",
    space6: "32px",
    space7: "40px",
    space8: "48px",
    space9: "56px",
    space10: "64px"
  };
  var font = {
    weightMedium: "500",
    weightRegular: "400",
    sizeHeadXl: '28px',
    sizeHeadL: '20px',
    sizeHeadM: '16px',
    sizeHeadS: '14px',
    sizeHeadXs: '12px',
    sizeBodyL: '16px',
    sizeBodyM: '14px',
    sizeBodyS: '12px',
    lineHeightXl: '36px',
    lineHeightL: '28px',
    lineHeightM: '24px',
    lineHeightS: '20px',
    lineHeightXs: '18px'
  };
  return {
    colors: colors,
    boxShadow: boxShadow,
    border: border,
    space: space,
    font: font
  };
}
var _a = getTheme(),
  colors = _a.colors,
  boxShadow = _a.boxShadow,
  border = _a.border,
  space = _a.space,
  font = _a.font;
export { colors, boxShadow, border, space, font, getTheme };